import * as React from 'react';
import { AdvantageData } from '../../CaseStudy/types';
import Advantage from '../Advantage/Advantage';
import { BTN_STYLES, Button } from '../Button/Button';
import { navigate } from 'gatsby';
import '../Advantage/AdvantageServicesList.scss';

interface ServicesListProps {
  data: AdvantageData;
  idx?: number;
}

const ServicesList = ({ data }: ServicesListProps) => {
  const servicesCards = [...data.icon];
  const title = data.title;
  const description = data.description;

  return (
    <section className="advantageList">
      <div className="advantageList__container">
        <div className="advantageList__textWrapper">
          <h2>{title}</h2>
          <p>{data && description}</p>
        </div>
        <div className="advantageList__advantagesWrapper">
          {servicesCards.map((prop: any, index: number) => {
            return <Advantage data={data} key={index} index={index} />;
          })}
        </div>
        <Button className={BTN_STYLES.BTN_PRIMARY_LARGE} title="Contact us" onClick={() => navigate('#yourIdea')} />
      </div>
    </section>
  );
};

export default ServicesList;
